import { TabType } from "@hooks/useTabs";
import EligibilityPage from "@sca/components/HowToNominate/components/Eligibility/EligibilityPage";
import NominationsPage from "@sca/components/HowToNominate/components/NominationsPage";
import SelectionsPage from "@sca/components/HowToNominate/components/Selections/SelectionsPage";

/**
 * Returns the corresponding static component to render based on the provided active tab identifier.
 *
 * This function is typically used to dynamically render different sections of the
 * Singapore Corporate Awards (SCA) How to Nominate page.
 *
 * @param page - The string identifier of the active tab (e.g., "nominations", "eligibility", "selections").
 * @returns The React component corresponding to the given page, or `undefined` if not matched.
 */
export const HowToNominateTabsFactory = (tab: TabType) => {
  switch (tab) {
    case "nominations":
      return NominationsPage;

    case "eligibility":
      return EligibilityPage;

    case "selections":
      return SelectionsPage;
  }
};
